import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, Transition as _Transition, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "fixed inset-0 z-100 w-screen overflow-y-auto" }
const _hoisted_2 = { class: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0" }
const _hoisted_3 = { class: "px-4 py-4 sm:px-6" }
const _hoisted_4 = { class: "flex items-start justify-between" }
const _hoisted_5 = { class: "text-left" }
const _hoisted_6 = { class: "mt-1 text-sm text-gray-500" }
const _hoisted_7 = { class: "sr-only" }
const _hoisted_8 = { class: "px-4 py-5 sm:px-6 space-y-6" }
const _hoisted_9 = {
  for: "name",
  class: "block text-sm/6 font-medium text-gray-900"
}
const _hoisted_10 = { class: "mt-2 grid grid-cols-1" }
const _hoisted_11 = {
  key: 0,
  class: "mt-2 text-sm text-red-600 text-left",
  id: "name-error"
}
const _hoisted_12 = {
  for: "date",
  class: "block text-sm/6 font-medium text-gray-900"
}
const _hoisted_13 = { class: "mt-2" }
const _hoisted_14 = {
  key: 0,
  class: "mt-2 text-sm text-red-600 text-left",
  id: "date-error"
}
const _hoisted_15 = { class: "relative mt-2" }
const _hoisted_16 = { class: "col-start-1 row-start-1 flex items-baseline gap-2 truncate pr-6" }
const _hoisted_17 = { class: "truncate" }
const _hoisted_18 = {
  key: 0,
  class: "text-xs text-gray-500 truncate"
}
const _hoisted_19 = { class: "flex items-baseline gap-2" }
const _hoisted_20 = {
  key: 0,
  class: "mt-2 text-sm text-red-600 text-left",
  id: "storage_period-error"
}
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "relative mt-2" }
const _hoisted_23 = { class: "col-start-1 row-start-1 flex items-center gap-2 pr-6" }
const _hoisted_24 = {
  key: 0,
  class: "size-6 shrink-0 overflow-hidden rounded bg-gray-100"
}
const _hoisted_25 = ["src", "alt"]
const _hoisted_26 = { class: "truncate" }
const _hoisted_27 = { class: "flex items-center gap-2" }
const _hoisted_28 = ["src", "alt"]
const _hoisted_29 = {
  key: 0,
  class: "mt-2 text-sm text-red-600 text-left",
  id: "copy_gallery_id-error"
}
const _hoisted_30 = { class: "mt-4 flex text-sm" }
const _hoisted_31 = { class: "group inline-flex items-start text-gray-500" }
const _hoisted_32 = { class: "ml-2 text-left" }
const _hoisted_33 = { class: "flex shrink-0 justify-end px-4 py-4 bg-gray-50" }
const _hoisted_34 = ["disabled"]
const _hoisted_35 = {
  key: 0,
  class: "animate-spin size-5",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TransitionChild = _resolveComponent("TransitionChild")!
  const _component_DialogTitle = _resolveComponent("DialogTitle")!
  const _component_XMarkIcon = _resolveComponent("XMarkIcon")!
  const _component_ExclamationCircleIcon = _resolveComponent("ExclamationCircleIcon")!
  const _component_DatePickerComponent = _resolveComponent("DatePickerComponent")!
  const _component_ListboxLabel = _resolveComponent("ListboxLabel")!
  const _component_ChevronUpDownIcon = _resolveComponent("ChevronUpDownIcon")!
  const _component_ListboxButton = _resolveComponent("ListboxButton")!
  const _component_CheckIcon = _resolveComponent("CheckIcon")!
  const _component_ListboxOption = _resolveComponent("ListboxOption")!
  const _component_ListboxOptions = _resolveComponent("ListboxOptions")!
  const _component_Listbox = _resolveComponent("Listbox")!
  const _component_QuestionMarkCircleIcon = _resolveComponent("QuestionMarkCircleIcon")!
  const _component_DialogPanel = _resolveComponent("DialogPanel")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_TransitionRoot = _resolveComponent("TransitionRoot")!

  return (_openBlock(), _createBlock(_component_TransitionRoot, {
    as: "template",
    show: _ctx.open
  }, {
    default: _withCtx(() => [
      _createVNode(_component_Dialog, {
        class: "relative z-100",
        onClose: _ctx.close
      }, {
        default: _withCtx(() => [
          _createVNode(_component_TransitionChild, {
            as: "template",
            enter: "ease-out duration-300",
            "enter-from": "opacity-0",
            "enter-to": "opacity-100",
            leave: "ease-in duration-200",
            "leave-from": "opacity-100",
            "leave-to": "opacity-0"
          }, {
            default: _withCtx(() => _cache[7] || (_cache[7] = [
              _createElementVNode("div", { class: "fixed inset-0 bg-gray-500/75 transition-opacity" }, null, -1)
            ])),
            _: 1
          }),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_TransitionChild, {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DialogPanel, { class: "relative transform rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg" }, {
                    default: _withCtx(() => [
                      _createElementVNode("form", {
                        onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"])),
                        class: "flex flex-col divide-y divide-gray-200 bg-white"
                      }, [
                        _createElementVNode("div", _hoisted_3, [
                          _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                              _createVNode(_component_DialogTitle, { class: "text-base font-semibold text-gray-900" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('create_gallery.title')), 1)
                                ]),
                                _: 1
                              }),
                              _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('create_gallery.text')), 1)
                            ]),
                            _createElementVNode("button", {
                              type: "button",
                              class: "relative rounded-md text-gray-400 hover:text-gray-500 focus-visible:ring-2 focus-visible:ring-royal-blue-500 focus:outline-hidden",
                              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
                            }, [
                              _cache[8] || (_cache[8] = _createElementVNode("span", { class: "absolute -inset-2.5" }, null, -1)),
                              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('create_gallery.close')), 1),
                              _createVNode(_component_XMarkIcon, {
                                class: "size-6",
                                "aria-hidden": "true"
                              })
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", null, [
                            _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('create_gallery.name')), 1),
                            _createElementVNode("div", _hoisted_10, [
                              _withDirectives(_createElementVNode("input", {
                                id: "name",
                                name: "name",
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.name) = $event)),
                                type: "text",
                                autocomplete: "name",
                                class: _normalizeClass({
                                                    'block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-royal-blue-600 sm:text-sm/6': true,
                                                    'col-start-1 row-start-1 block w-full rounded-md bg-white py-1.5 pr-10 pl-3 text-base text-red-900 outline-1 -outline-offset-1 outline-red-300 placeholder:text-red-300 focus:outline-2 focus:-outline-offset-2 focus:outline-red-600 sm:pr-9 sm:text-sm/6': _ctx.hasError('name')
                                                })
                              }, null, 2), [
                                [_vModelText, _ctx.form.name]
                              ]),
                              (_ctx.hasError('name'))
                                ? (_openBlock(), _createBlock(_component_ExclamationCircleIcon, {
                                    key: 0,
                                    class: "pointer-events-none col-start-1 row-start-1 mr-3 size-5 self-center justify-self-end text-red-500 sm:size-4",
                                    "aria-hidden": "true"
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            (_ctx.hasError('name'))
                              ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.getError('name')), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('create_gallery.date')), 1),
                            _createElementVNode("div", _hoisted_13, [
                              _createVNode(_component_DatePickerComponent, {
                                id: "date",
                                modelValue: _ctx.form.date,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.date) = $event)),
                                error: _ctx.hasError('date'),
                                placeholder: _ctx.$t('create_gallery.date')
                              }, null, 8, ["modelValue", "error", "placeholder"])
                            ]),
                            (_ctx.hasError('date'))
                              ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_ctx.getError('date')), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", null, [
                            _createVNode(_component_Listbox, {
                              as: "div",
                              modelValue: _ctx.form.storage_period,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.storage_period) = $event))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ListboxLabel, { class: "block text-sm/6 font-medium text-gray-900" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('create_gallery.storage_period')), 1)
                                  ]),
                                  _: 1
                                }),
                                _createElementVNode("div", _hoisted_15, [
                                  _createVNode(_component_ListboxButton, {
                                    class: _normalizeClass([
                                                        'grid w-full cursor-default grid-cols-1 rounded-md bg-white py-1.5 pr-2 pl-3 text-left text-gray-900 outline-1 -outline-offset-1 sm:text-sm/6',
                                                        _ctx.hasError('storage_period') ? 'outline-red-300 focus:outline-2 focus:-outline-offset-2 focus:outline-red-600' : 'outline-gray-300 focus:outline-2 focus:-outline-offset-2 focus:outline-royal-blue-600'
                                                    ])
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("span", _hoisted_16, [
                                        _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.selectedStoragePeriodLabel), 1),
                                        (_ctx.storagePeriodUntil(_ctx.form.storage_period))
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.storagePeriodUntil(_ctx.form.storage_period)), 1))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createVNode(_component_ChevronUpDownIcon, {
                                        class: "col-start-1 row-start-1 size-5 self-center justify-self-end text-gray-500 sm:size-4",
                                        "aria-hidden": "true"
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["class"]),
                                  _createVNode(_Transition, {
                                    "leave-active-class": "transition ease-in duration-100",
                                    "leave-from-class": "opacity-100",
                                    "leave-to-class": "opacity-0"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ListboxOptions, { class: "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base ring-1 shadow-lg ring-black/5 focus:outline-hidden sm:text-sm" }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.storage_periods, (period) => {
                                            return (_openBlock(), _createBlock(_component_ListboxOption, {
                                              as: "template",
                                              key: `storage-period-option-${period.value}`,
                                              value: period.value
                                            }, {
                                              default: _withCtx(({ active, selected }) => [
                                                _createElementVNode("li", {
                                                  class: _normalizeClass([active ? 'bg-royal-blue-600 text-white outline-hidden' : 'text-gray-900', 'relative cursor-default py-2 pr-9 pl-3 select-none'])
                                                }, [
                                                  _createElementVNode("span", _hoisted_19, [
                                                    _createElementVNode("span", {
                                                      class: _normalizeClass([selected ? 'font-semibold' : 'font-normal', 'truncate'])
                                                    }, _toDisplayString(period.label), 3),
                                                    (_ctx.storagePeriodUntil(period.value))
                                                      ? (_openBlock(), _createElementBlock("span", {
                                                          key: 0,
                                                          class: _normalizeClass([active ? 'text-white/80' : 'text-gray-500', 'text-xs truncate'])
                                                        }, _toDisplayString(_ctx.storagePeriodUntil(period.value)), 3))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  selected
                                                    ? (_openBlock(), _createElementBlock("span", {
                                                        key: 0,
                                                        class: _normalizeClass([active ? 'text-white' : 'text-royal-blue-600', 'absolute inset-y-0 right-0 flex items-center pr-4'])
                                                      }, [
                                                        _createVNode(_component_CheckIcon, {
                                                          class: "size-5",
                                                          "aria-hidden": "true"
                                                        })
                                                      ], 2))
                                                    : _createCommentVNode("", true)
                                                ], 2)
                                              ]),
                                              _: 2
                                            }, 1032, ["value"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _: 1
                            }, 8, ["modelValue"]),
                            (_ctx.hasError('storage_period'))
                              ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(_ctx.getError('storage_period')), 1))
                              : _createCommentVNode("", true)
                          ]),
                          (_ctx.galleries.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                _createVNode(_component_Listbox, {
                                  as: "div",
                                  modelValue: _ctx.form.copy_gallery_id,
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.copy_gallery_id) = $event))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ListboxLabel, { class: "block text-sm/6 font-medium text-gray-900" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('create_gallery.copy_gallery')), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createElementVNode("div", _hoisted_22, [
                                      _createVNode(_component_ListboxButton, {
                                        class: _normalizeClass([
                                                        'grid w-full cursor-default grid-cols-1 rounded-md bg-white py-1.5 pr-2 pl-3 text-left text-gray-900 outline-1 -outline-offset-1 sm:text-sm/6',
                                                        _ctx.hasError('copy_gallery_id') ? 'outline-red-300 focus:outline-2 focus:-outline-offset-2 focus:outline-red-600' : 'outline-gray-300 focus:outline-2 focus:-outline-offset-2 focus:outline-royal-blue-600'
                                                    ])
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("span", _hoisted_23, [
                                            (_ctx.selectedCopyGallery)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                                                  (_ctx.selectedCopyGallery.small_cover_url)
                                                    ? (_openBlock(), _createElementBlock("img", {
                                                        key: 0,
                                                        src: _ctx.selectedCopyGallery.small_cover_url,
                                                        alt: _ctx.selectedCopyGallery.name,
                                                        class: "size-full object-cover"
                                                      }, null, 8, _hoisted_25))
                                                    : _createCommentVNode("", true)
                                                ]))
                                              : _createCommentVNode("", true),
                                            _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.selectedCopyGallery ? _ctx.selectedCopyGallery.name : _ctx.$t('create_gallery.copy_gallery_no')), 1)
                                          ]),
                                          _createVNode(_component_ChevronUpDownIcon, {
                                            class: "col-start-1 row-start-1 size-5 self-center justify-self-end text-gray-500 sm:size-4",
                                            "aria-hidden": "true"
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["class"]),
                                      _createVNode(_Transition, {
                                        "leave-active-class": "transition ease-in duration-100",
                                        "leave-from-class": "opacity-100",
                                        "leave-to-class": "opacity-0"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ListboxOptions, { class: "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base ring-1 shadow-lg ring-black/5 focus:outline-hidden sm:text-sm" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ListboxOption, {
                                                as: "template",
                                                value: null
                                              }, {
                                                default: _withCtx(({ active, selected }) => [
                                                  _createElementVNode("li", {
                                                    class: _normalizeClass([active ? 'bg-royal-blue-600 text-white outline-hidden' : 'text-gray-900', 'relative cursor-default py-2 pr-9 pl-3 select-none'])
                                                  }, [
                                                    _createElementVNode("span", {
                                                      class: _normalizeClass([selected ? 'font-semibold' : 'font-normal', 'block truncate'])
                                                    }, _toDisplayString(_ctx.$t('create_gallery.copy_gallery_no')), 3),
                                                    selected
                                                      ? (_openBlock(), _createElementBlock("span", {
                                                          key: 0,
                                                          class: _normalizeClass([active ? 'text-white' : 'text-royal-blue-600', 'absolute inset-y-0 right-0 flex items-center pr-4'])
                                                        }, [
                                                          _createVNode(_component_CheckIcon, {
                                                            class: "size-5",
                                                            "aria-hidden": "true"
                                                          })
                                                        ], 2))
                                                      : _createCommentVNode("", true)
                                                  ], 2)
                                                ]),
                                                _: 1
                                              }),
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.galleries, (gallery) => {
                                                return (_openBlock(), _createBlock(_component_ListboxOption, {
                                                  as: "template",
                                                  key: `gallery-copy-item-select-${gallery.id}`,
                                                  value: gallery.id
                                                }, {
                                                  default: _withCtx(({ active, selected }) => [
                                                    _createElementVNode("li", {
                                                      class: _normalizeClass([active ? 'bg-royal-blue-600 text-white outline-hidden' : 'text-gray-900', 'relative cursor-default py-2 pr-9 pl-3 select-none'])
                                                    }, [
                                                      _createElementVNode("span", _hoisted_27, [
                                                        _createElementVNode("span", {
                                                          class: _normalizeClass([active ? 'bg-white/20' : 'bg-gray-100', 'size-6 shrink-0 overflow-hidden rounded'])
                                                        }, [
                                                          (gallery.small_cover_url)
                                                            ? (_openBlock(), _createElementBlock("img", {
                                                                key: 0,
                                                                src: gallery.small_cover_url,
                                                                alt: gallery.name,
                                                                class: "size-full object-cover"
                                                              }, null, 8, _hoisted_28))
                                                            : _createCommentVNode("", true)
                                                        ], 2),
                                                        _createElementVNode("span", {
                                                          class: _normalizeClass([selected ? 'font-semibold' : 'font-normal', 'block truncate'])
                                                        }, _toDisplayString(gallery.name), 3)
                                                      ]),
                                                      selected
                                                        ? (_openBlock(), _createElementBlock("span", {
                                                            key: 0,
                                                            class: _normalizeClass([active ? 'text-white' : 'text-royal-blue-600', 'absolute inset-y-0 right-0 flex items-center pr-4'])
                                                          }, [
                                                            _createVNode(_component_CheckIcon, {
                                                              class: "size-5",
                                                              "aria-hidden": "true"
                                                            })
                                                          ], 2))
                                                        : _createCommentVNode("", true)
                                                    ], 2)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["value"]))
                                              }), 128))
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"]),
                                (_ctx.hasError('copy_gallery_id'))
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_29, _toDisplayString(_ctx.getError('copy_gallery_id')), 1))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_30, [
                                  _createElementVNode("p", _hoisted_31, [
                                    _createVNode(_component_QuestionMarkCircleIcon, {
                                      class: "size-5 text-gray-400 shrink-0",
                                      "aria-hidden": "true"
                                    }),
                                    _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$t('create_gallery.copy_gallery_info')), 1)
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 shadow-xs ring-gray-300 ring-inset hover:bg-gray-50 cursor-pointer",
                            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
                          }, _toDisplayString(_ctx.$t('create_gallery.cancel_button')), 1),
                          _createElementVNode("button", {
                            type: "submit",
                            disabled: _ctx.isCreating,
                            class: _normalizeClass({'ml-4 inline-flex justify-center items-center gap-2 rounded-md px-3 py-2 text-sm font-semibold text-white shadow-xs focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-royal-blue-600': true, 'bg-royal-blue-600 hover:bg-royal-blue-700 cursor-pointer': !_ctx.isCreating, 'bg-royal-blue-400 cursor-not-allowed': _ctx.isCreating})
                          }, [
                            (_ctx.isCreating)
                              ? (_openBlock(), _createElementBlock("svg", _hoisted_35, _cache[9] || (_cache[9] = [
                                  _createElementVNode("circle", {
                                    class: "opacity-25",
                                    cx: "12",
                                    cy: "12",
                                    r: "10",
                                    stroke: "currentColor",
                                    "stroke-width": "4"
                                  }, null, -1),
                                  _createElementVNode("path", {
                                    class: "opacity-75",
                                    fill: "currentColor",
                                    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                  }, null, -1)
                                ])))
                              : _createCommentVNode("", true),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('create_gallery.create_button')), 1)
                          ], 10, _hoisted_34)
                        ])
                      ], 32)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["onClose"])
    ]),
    _: 1
  }, 8, ["show"]))
}